/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ClientFailuresSummaryResponse interface.
 */
export function instanceOfClientFailuresSummaryResponse(value) {
    if (!('byErrorClass' in value) || value['byErrorClass'] === undefined)
        return false;
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('totalToday' in value) || value['totalToday'] === undefined)
        return false;
    return true;
}
export function ClientFailuresSummaryResponseFromJSON(json) {
    return ClientFailuresSummaryResponseFromJSONTyped(json, false);
}
export function ClientFailuresSummaryResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'byErrorClass': json['by_error_class'],
        'date': json['date'],
        'totalToday': json['total_today'],
    };
}
export function ClientFailuresSummaryResponseToJSON(json) {
    return ClientFailuresSummaryResponseToJSONTyped(json, false);
}
export function ClientFailuresSummaryResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'by_error_class': value['byErrorClass'],
        'date': value['date'],
        'total_today': value['totalToday'],
    };
}
